// global wrapper
export const Wrapper = ({ children }) => {
  return children;
};

export default Wrapper;
